import { render, staticRenderFns } from "./WoocommerceKategori.vue?vue&type=template&id=4278eb92&scoped=true"
import script from "./WoocommerceKategori.vue?vue&type=script&lang=js"
export * from "./WoocommerceKategori.vue?vue&type=script&lang=js"
import style0 from "./WoocommerceKategori.vue?vue&type=style&index=0&id=4278eb92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4278eb92",
  null
  
)

export default component.exports